import {Component, ViewEncapsulation} from '@angular/core';
import {MatTab, MatTabContent, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {MatIcon} from '@angular/material/icon';
import {EsvgFiles} from 'frontier';
import {EvaluateInvoicesComponent} from './evaluate-invoices/evaluate-invoices.component';
import {EvaluateTransportsComponent} from './evaluate-transports/evaluate-transports.component';
import {TabActivatedDirective} from 'frontier/browserkit/src/lib/directives/tab-activated.directive';
import {EvaluateCartsComponent} from "./evaluate-carts/evaluate-carts.component";
import {BookingRecordExportComponent} from "./booking-record-export/booking-record-export.component";

@Component({
  selector: 'app-billing-evaluations',
  standalone: true,
  imports: [
    MatTabGroup,
    MatTab,
    MatIcon,
    MatTabLabel,
    MatTabContent,
    EvaluateInvoicesComponent,
    EvaluateTransportsComponent,
    TabActivatedDirective,
    EvaluateCartsComponent,
    BookingRecordExportComponent,
  ],
  templateUrl: './billing-evaluations.component.html',
  styleUrl: './billing-evaluations.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class BillingEvaluationsComponent {
  protected readonly EsvgFiles: typeof EsvgFiles = EsvgFiles;
  tabIndex: number = 0;

  onSelectedIndexChange(evt: number): void {
    this.tabIndex = evt;
  }
}
